exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.identity-validation-countdown-banner[data-v-02199e0d] {\r\n    width: 100%;\r\n    padding: 10px 14px;\r\n    background: #c00;\r\n    color: #fff;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    line-height: 1.4;\r\n    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\r\n            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n.identity-validation-countdown-banner[data-v-02199e0d]:hover {\r\n    background: #a00;\n}\n.banner-text[data-v-02199e0d] {\r\n    display: inline-block;\n}\r\n", ""]);

// exports
